import React, { useCallback, useState } from "react";
import { makeStyles } from '@material-ui/core/styles';
import ComponentBox from './Tools'
import Canvas from './Table'


function CreateTemplate(props) {


  const useStyles = makeStyles(theme => ({
    root: {
      width: '100%',
      height: '100%',
      overflow: 'auto'
    },
    grid: {
      display: 'flex',
      overflow: 'auto'
    },
  }));

  const classes = useStyles();
  var data = {};
  var json = {};
  var mode = "create";
  if(props.location.state){
    json = JSON.parse(props.location.state.data.json);
    props.location.state.data.json = json;
    data = props.location.state.data;
    mode ="edit";
  }
  return (
    <div style={{width:'100%',height:'100%',overflow:'auto'}}>
      
      <div className={classes.grid}>
      
        <ComponentBox/>
        <Canvas data={data} mode={mode} />
      </div>

    </div>
  );
}

export default CreateTemplate;